/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';

import { STORE_PROFILE, STORE_ROUTER, STORE_USER } from 'src/constants';
import sites from 'src/constants/sites';
/** Stylesheet Imports */
import './Menu.css';

import { inject, observer } from 'mobx-react';
import MobileNavigation from './MobileNavigation';
import { UserStore } from 'src/shared/stores/UserStore';
import { RouterStore } from 'mobx-react-router';
import { ProfileStore } from 'src/shared/stores/ProfileStore';
export interface Props {
    children?: React.ReactNode;
}

export interface State {
    searchText: string;
    dropdownOpen: {
        product: boolean,
        features: boolean,
        resources: boolean,
        about: boolean,
        search: boolean,
        account: boolean
    },
}

@inject(STORE_USER, STORE_ROUTER, STORE_PROFILE)
@observer
export default class Menu extends React.Component<Props, State> {
    public userStore: UserStore = this.props[STORE_USER];
    public routerStore: RouterStore = this.props[STORE_ROUTER];
    public profileStore: ProfileStore = this.props[STORE_PROFILE];

    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            searchText: '',
            dropdownOpen: {
                product: false,
                features: false,
                resources: false,
                about: false,
                search: false,
                account: false
            },
        };
    }

    toggleDropdown = (dropdown: string) => {
        this.setState(prevState => ({
            dropdownOpen: {
                product: dropdown === 'product',
                features: dropdown === 'features',
                resources: dropdown === 'resources',
                about: dropdown === 'about',
                search: dropdown === 'search',
                account: dropdown === 'account'
            }
        }
        ));
    };
    onMouseLeaveDropdown = () => {
        this.setState(prevState => ({
            dropdownOpen: {
                product: false,
                features: false,
                resources: false,
                about: false,
                search: false,
                account: false
            }
        }
        ));
    };

    onSearchClickJS = () => {
        window.location.href = '/search.aspx';
        if (document.getElementById('dmsearch').classList.contains('dmsearch-open')) {
            window.location.href = '/search.aspx';
        }
        return false;
    };

    setSearchText = (e: string) => {
        this.setState(prevState => ({
            searchText: e
        }))
    }

    handleSearchClick = () => {
        const searchPattern = encodeURIComponent(this.state.searchText);
        window.location.href = `Search.aspx?searchPattern=${searchPattern}`;
    };

    render() {
        return (
          <header className="header clearfix affix-top">
            <div className="header-navbar header-container fhmm" role="navigation">
                    <div className="navbar-home">
                        <a href="/" title="Home">
                            <img className="header-logo" src="/VisualCronBlue.png" alt="VisualCron logo" />
                        </a>
                    </div>
                    <div className="header-mobile">
                        <MobileNavigation />
                    </div>

                 <div className="navbar-tabs header-collapse__mobile">
                        <ul className="header-navbar align-items-end">
                            <li className="logo-wrapper clearfix"></li>
                            <li onMouseLeave={this.onMouseLeaveDropdown} className={(this.state.dropdownOpen.product ? 'open ' : '') + "dropdown fhmm-fw h-100 header-collapse__md"}>
                                <a href="#" onMouseOver={() => this.toggleDropdown('product')} className="header-tab">
                                    <div>Product</div>
                                </a>
                                <div className="dropdown-menu fullwidth fhmm-fw tab-dropdown">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-4 text-nowrap">
                                                <div className="dropdown-category_header pt-2">VisualCron</div>
                                                <hr className="dropdown-ruler" />
                                                <ul className="dropdown-menu_list">
                                                    <li><a href={`${sites.main}/about`}>What is VisualCron?</a></li>
                                                    <li><a href={`${sites.main}/choosing-license`}>Choosing the Right License</a></li>
                                                    <li><a href={`${sites.main}/compare-licenses`}>Compare Licenses</a></li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4 text-nowrap">
                                                <div className="dropdown-category_header pt-2">Features</div>
                                                <hr className="dropdown-ruler" />
                                                <ul className="dropdown-menu_list">
                                                    <li><a href={`${sites.main}/automation`}>General Automation</a></li>
                                                    <li><a href={`${sites.main}/job-scheduling-software`}>Enterprise Job Scheduling</a></li>
                                                    <li><a href={`${sites.main}/load-balancing`}>Load Balancing</a></li>
                                                    <li><a href={`${sites.main}/task-scheduler`}>Task Scheduler</a></li>
                                                    <li><a href={`${sites.main}/api`}>API</a></li>
                                                    <li><a href={`${sites.main}/tasks`}>Tasks</a></li>
                                                    <li><a href={`${sites.main}/triggers`}>Triggers</a></li>
                                                    <li><a href={`${sites.main}/connections`}>Connections</a></li>
                                                    <li><a href={`${sites.main}/business-process-automation`}>Business Process Automation (BPA)</a></li>
                                                    <li><a href={`${sites.main}/mft-managed-file-transfer`}>Managed File Transfer (MFT)</a></li>
                                                </ul>
                                            </div>
                                            <div className="dropdown-cta col-md-4">
                                                <div className="dropdown-category_header dropdown-title">Take a Tour</div>
                                                <p className="dropdown-desc"></p><p>Get a customized tour of VisualCron's automation, integration, and task scheduling capabilities.</p><p></p>
                                                <a href={`${sites.main}/take-a-tour`} className="button button-blue">Take a Tour</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </li>
                            {/* Features dropdown not present in Tabs.ascx; omitted to mirror layout */}
                            <li onMouseLeave={this.onMouseLeaveDropdown} className={(this.state.dropdownOpen.resources ? 'open ' : '') + "dropdown fhmm-fw header-collapse"}>
                                <a href="#" onMouseOver={() => this.toggleDropdown('resources')} className="header-tab">Resources</a>
                                <div className="dropdown-menu fullwidth tab-dropdown">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="dropdown-category_header pt-2">Product Support</div>
                                                <hr className="dropdown-ruler" />
                                                <ul className="dropdown-menu_list">
                                                    <li><a href={`${sites.main}/tutorials`}>Video Tutorials</a></li>
                                                    <li><a href="https://help.visualcron.com/">Documentation</a></li>
                                                    <li><a href="https://help.visualcron.com/changelog">Changelog</a></li>
                                                    <li><a href={`${sites.admin}/contact.aspx`}>Contact Support</a></li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="dropdown-category_header pt-2">Our Clients</div>
                                                <hr className="dropdown-ruler" />
                                                <ul className="dropdown-menu_list">
                                                    <li><a href={`${sites.main}/customers`}>Customers</a></li>
                                                    <li><a href={`${sites.main}/resellers`}>Partners</a></li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="dropdown-category_header pt-2">&nbsp;</div>                                              
                                                <ul className="dropdown-menu_list"></ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </li>

                            {/* About dropdown not present in Tabs.ascx; omitted to mirror layout */}
                            <li className="fhmm-fw"><a href={`${sites.admin}/order.aspx`} className="header-tab">Pricing</a></li>
                        </ul>
                    </div>
                    <div className="header-account">
                        <div onMouseLeave={this.onMouseLeaveDropdown} className={(this.state.dropdownOpen.search ? 'open ' : '') + "fhmm-fw"}>
                            <a href="/search.aspx" data-toggle="dropdown" className="dmsearch" onMouseOver={() => this.toggleDropdown('search')}>
                                <div className="dmsearch">
                                    <span className="header-searchicon" onMouseDown={() => this.onSearchClickJS()}></span>
                                </div>
                            </a>

                            <div className="dropdown-menu fullwidth tab-dropdown">
                                <div className="dropdown-search">
                                    <input
                                        type="text"
                                        id="s"
                                        className="search-textbox"
                                        value={this.state.searchText}
                                        onChange={(e) => this.setSearchText(e.target.value)}
                                        placeholder=""
                                    />
                                    <button
                                        id="go"
                                        className="search-button"
                                        onClick={this.handleSearchClick}
                                    >
                                        <i className="fa fa-search"></i> Search
                                    </button>
                                </div>

                            </div>
                        </div>

                        <div className="header-ruler"></div>
                        <div className="account-bar">
                            <a href={`${sites.admin}/contact.aspx`} className="header-tab">Contact Sales</a>
                        </div>

                    </div>
                </div>
            </header>
        );
    }
}
